import { Controller } from '@hotwired/stimulus';

export default class extends Controller {
  static targets = ['button'];

  submit() {
    if (this.hasButtonTarget) {
      this.buttonTarget.disabled = true;
    }
  }
}
